import { render, staticRenderFns } from "./AlertManager.vue?vue&type=template&id=0061c1e7&"
import script from "./AlertManager.vue?vue&type=script&lang=js&"
export * from "./AlertManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports